import React from 'react';
import Desktop from './Desktop';

const Views = props => {
  return <Desktop {...props} />;
};
export default Views;
